import {
	createNamespacedHelpers
} from 'vuex';
import common from '@/util/common';
const sroreName = {
	result: 'pageInfo',
};
const {
	mapActions
} = createNamespacedHelpers(sroreName.result);
export default {
	data() {
		return {
			loginData: null, //登录cookie数据
			userName: '', //手机号
			cardId: '', //身份证
			clientHeight: '', //可视区域高度
			login_type: 'password',//登录方式
			psdValue: '',//登录密码
			getConfData: null,//系统配置信息
			wxAppid: 'wx39c6e5208437579c',//微信appid
			isSelectLoginFlag: false,//是否去选择登录界面，建行环境不去，非建行环境去，根据链接search是否有user_id判断
			user_id: '',//建行跳转该界面带的user_id参数
			loginWay: '',//登录环境，提供给支付用，建行环境0，非建行2
			isScrollTopFlag: false,//是否往上移动，用在安卓建行环境下，聚焦input输入框时
			isAndroid: false,//判断是否是安卓浏览器
			show:false,
			expendCard:['card1','card2'],
            noticeList:[], //公告列表
            page_content:''
		};
	},
	async created(){
	},
	async mounted() {
        window.scrollTo(0, 0);

		this.loadData();
	},
	components: {

	},
	watch: {

	},
	computed: {

	},
	methods: {
		...mapActions({
			getPageInfo: 'getPageInfo'
		}),
		async loadData(){
            const pageId = this.$route.query.id;
            console.log('页面ID：', this);

            if(pageId){
                const resultData = await this.getPageInfo({
                    content: this,
                    data: {
                        id: pageId
                    }
                });
                this.page_content = resultData;
            }
        },
		toAskCourse(){

		},
		toApplyCourse(){
			common.jump(this,'apply');
		},
		goBack(){
            common.goBack(this);
        },
	}
};
